import InlineFormsCommandBar from './InlineFormsCommandBar';
import getBirthdayPeekCommandBarItems from '../utils/getBirthdayPeekCommandBarItems';
import getPeekCommandBarItems from '../utils/getPeekCommandBarItems';
import { observer } from 'mobx-react-lite';
import type { ViewType } from 'owa-calendar-actions';
import { canModify, isBirthdayEvent } from 'owa-calendar-event-capabilities';
import { FormsCommandBar } from 'owa-calendar-forms-command-bar';
import { getNotesEditorViewState, NotesEditor } from 'owa-calendar-notes-editor';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import type EventScope from 'owa-service/lib/contract/EventScope';
import type ResponseTypeType from 'owa-service/lib/contract/ResponseTypeType';
import { getPalette } from 'owa-theme';
import * as React from 'react';

const styles = require('./CalendarItemPeek.scss');

export interface PeekEventCommandBarProps {
    item: CalendarEvent;
    colorScheme: ColorScheme;
    actionSource: ViewType;
    onEditClicked: (eventScope: EventScope) => void;
    onDeleteClicked: (eventScope: EventScope) => void;
    onRespondClicked: (
        newResponseType: ResponseTypeType,
        eventScope: EventScope,
        sendMessage: boolean,
        notes: string
    ) => void;
    onDismiss?: () => void;
    showInlineCommandBar: boolean;
}

export default observer(function PeekEventCommandBar(props: PeekEventCommandBarProps) {
    const {
        item,
        colorScheme,
        actionSource,
        onEditClicked,
        onDeleteClicked,
        onRespondClicked,
        onDismiss,
        showInlineCommandBar,
    } = props;

    const shouldShowCommandBar = canModify(item) || isBirthdayEvent(item);
    if (!shouldShowCommandBar) {
        return null;
    }

    const commandBarContainerStyle = {
        backgroundColor: colorScheme ? colorScheme.calLighterAlt : getPalette().neutralLighterAlt,
    };

    const notesEditorViewState = getNotesEditorViewState(item.ItemId);
    if (notesEditorViewState) {
        return (
            <div style={commandBarContainerStyle} className={styles.commandBarContainer}>
                <div className={styles.notesEditorContainer}>
                    <NotesEditor id={item.ItemId} isNarrow={true} colorScheme={colorScheme} />
                </div>
            </div>
        );
    }

    const filterableItems = isBirthdayEvent(item)
        ? getBirthdayPeekCommandBarItems(item, actionSource, onDeleteClicked)
        : getPeekCommandBarItems(
              item,
              actionSource,
              onEditClicked,
              onDeleteClicked,
              onRespondClicked,
              onDismiss,
              showInlineCommandBar
          );

    if (showInlineCommandBar) {
        return (
            <div className={styles.commandBarContainer}>
                <div className={styles.inlineCommandBarContainerRow}>
                    <InlineFormsCommandBar
                        filterableItems={filterableItems}
                        colorScheme={colorScheme}
                    />
                </div>
            </div>
        );
    } else {
        return (
            <div className={styles.commandBarContainer} style={commandBarContainerStyle}>
                <FormsCommandBar
                    filterableItems={filterableItems}
                    className={styles.commandBar}
                    colorScheme={colorScheme}
                />
            </div>
        );
    }
});
